const env = {
  // SERVER: 'https://api.artichokeapp.com',
  SERVER: 'https://api.artichokeapp.com',
  // API_URL: 'https://api.artichoke.live/api',
  API_URL: 'https://api.artichoke.live/api',
}

export default env
